// Copyright (c) 2020 Deere & Company

import actionCreators from './action-creator/index';
import { connect } from 'react-redux';
import pinSearchSettings from './components/pin-search';
import { showLoadingIndicator } from '../../../sharedmodules/state/busy-counter';
import { withAuth } from '@okta/okta-react';

const mapStateToProps = (state) => ({
    accountLookup: state.application.createTransfer.accountLookup,
    dealerSearchModal: state.application.createTransfer.dealerSearchModal,
    isAmountOfUseModalOpen: state.application.createTransfer.isAmountOfUseModalOpen,
    measurementReadings: state.application.latestPerUnitMeasurements,
    newTransfer: state.application.createTransfer.newTransfer,
    newTransferStatusChangeModal: state.application.createTransfer.newTransferStatusChangeModal,
    pinSearchResult: state.application.pinSearchSetting.pinSearch,
    busyCounter: showLoadingIndicator(state.application.busyCounter),
});

const mapActionsToProps = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
    },
});
export default connect(
    mapStateToProps, actionCreators, mapActionsToProps,
)(withAuth(pinSearchSettings));
